export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000' as const;
export const NATIVE_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE' as const;
